export default "__VITE_ASSET__a2ece413__"